<template>
  <div class="schedule schedule--place background-gray min-height-inherit">
    <section class="py-4 py-md-5">
      <div class="container container--md">
        <div class="mb-3 d-none d-lg-block">
          <schedule-breadcrumb />
        </div>
        <div class="box box-sm-none">
          <div class="schedule__content schedule__content--place mx-auto">
            <ValidationObserver
              class="form"
              ref="observer"
              v-slot="{}"
              tag="form"
              autocomplete="off"
              @submit.prevent="handleSubmit"
            >
              <fieldset class="form__item">
                <legend class="form__legend title title--main mb-4">
                  Selecciona lugar:
                </legend>
                <div class="form__fields">
                  <ValidationProvider
                    class="form-group"
                    name="región"
                    vid="region"
                    rules="required"
                    v-slot="{ classes, errors }"
                    tag="div"
                  >
                    <label
                      :class="['form-label weight-bold', classes]"
                      for="region"
                      >Región</label
                    >
                    <div :class="['form-select', classes]">
                      <select
                        :class="['form-control', classes]"
                        id="region"
                        v-model="data.region"
                        @change="handleGetCommunes"
                      >
                        <option disabled>Selecciona una región</option>
                        <option
                          v-for="region in regions"
                          :value="region"
                          :key="region.id"
                          >{{ region.name }}</option
                        >
                      </select>
                    </div>
                    <span class="form-helper form-helper--error">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="form-group"
                    name="comuna"
                    vid="commune"
                    rules="required"
                    v-slot="{ classes, errors }"
                    tag="div"
                  >
                    <label
                      :class="['form-label weight-bold', classes]"
                      for="commune"
                      >Comuna</label
                    >
                    <div :class="['form-select', classes]">
                      <select
                        :class="['form-control', classes]"
                        id="commune"
                        v-model="data.commune"
                        @change="handleGetOffices"
                      >
                        <option disabled>Selecciona una comuna</option>
                        <option
                          v-for="commune in communes"
                          :value="commune"
                          :key="commune.id"
                          >{{ commune.name }}</option
                        >
                      </select>
                    </div>
                    <span class="form-helper form-helper--error">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                  <ValidationProvider
                    class="form-group"
                    name="sucursal"
                    vid="office"
                    rules="required"
                    v-slot="{ classes, errors }"
                    tag="div"
                  >
                    <label
                      :class="['form-label weight-bold', classes]"
                      for="office"
                      >Selecciona una sucursal</label
                    >
                    <div
                      :class="['form-select form-select--office', classes]"
                      @click="handleShowModal(true)"
                    >
                      <card-office
                        :class="['form-control card-office--input', classes]"
                        :data="selectedOffice"
                        :disabled="!offices"
                        id="office"
                        v-model="data.office"
                      />
                    </div>
                    <span class="form-helper form-helper--error">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </fieldset>
              <div class="text-center mt-2">
                <button class="button button--secondary" type="submit">
                  <span class="button__text">Continuar</span>
                  <i class="button__icon material-icons">arrow_forward</i>
                </button>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </section>

    <modal v-if="showModal" @close="handleShowModal(false)">
      <div slot="body">
        <div class="schedule-place__scroll scroll">
          <div class="scroll__content">
            <div
              v-for="office in offices"
              class="mb-3 last-child"
              :key="office.id"
              @click="onSetOffice(office)"
            >
              <card-office class="card-office--default" :data="office" />
            </div>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { getRegions, getCommunes, getOffices } from '@/services/places';

import CardOffice from '@/components/CardOffice.vue';
import Modal from '@/components/Modal.vue';
import ScheduleBreadcrumb from '@/components/ScheduleBreadcrumb.vue';
import Auth from '@/helpers/auth';

import { mapState } from 'vuex';

export default {
  name: 'SchedulePlace',
  mixins: [Auth],
  components: {
    CardOffice,
    Modal,
    ScheduleBreadcrumb,
  },
  data() {
    return {
      loading: false,
      regions: [],
      communes: [],
      offices: null,
      data: {
        region: null,
        commune: null,
        office: null,
      },
      showModal: false,
    };
  },
  mounted() {
    this.$store.commit('set_title', 'Estás agendando');

    this.checkAuth();

    this.executeDataLayer();

    this.$store.dispatch('setCurrentStep', 2);
    this.handleGetRegions();

    if (this.current_schedule.office) {
      this.data.region = this.current_schedule.office.region;
      this.data.commune = this.current_schedule.office.commune;
      this.data.office = this.current_schedule.office.office;
      this.handleGetCommunes();
      this.handleGetOffices();
    }
  },
  computed: {
    ...mapState(['current_schedule']),
    selectedOffice() {
      return Array.isArray(this.offices)
        ? this.offices.length
          ? this.offices.find(
              o => o.id === (this.data.office && this.data.office.id),
            )
          : {
              name: 'No hay sucursales',
              address: 'Intenta con otra ubicación',
            }
        : {};
    },
  },
  methods: {
    executeDataLayer: async function() {
      if (!window.dataLayer) {
        return;
      }

      const eventData = {
        event: 'agendamiento-paso',
        paso: 2,
      };

      console.log('Sent to dataLayer', eventData);

      window.dataLayer.push(eventData);
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      this.submitForm();
    },
    submitForm() {
      this.loading = true;

      this.$store
        .dispatch('setSelectedOffice', this.data)
        .then(() => this.$router.push({ name: 'schedule-date' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido registrar la oficina seleccionada',
          });
        })
        .then(() => {
          this.loading = false;
        });
    },
    onSetOffice(data) {
      this.handleShowModal(false);
      this.data.office = data;
    },
    handleShowModal(show) {
      if (this.offices && this.offices.length) {
        this.showModal = show;
      }
    },
    handleGetRegions() {
      this.getRegionsFromApi(this.current_schedule.service.id)
        .then(regions => (this.regions = regions))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener las regiones',
          });
        });
    },
    handleGetCommunes() {
      this.data.commune = null;
      this.data.office = null;
      this.offices = null;

      if (!this.data.region) return;

      this.getCommunesFromApi(
        this.data.region.id,
        this.current_schedule.service.id,
      )
        .then(communes => (this.communes = communes))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener las comunas',
          });
        });
    },
    handleGetOffices() {
      this.data.office = null;
      this.offices = null;

      if (!this.data.commune) return;

      this.getOfficesFromApi(
        this.data.commune.id,
        this.current_schedule.service.id,
      )
        .then(offices => (this.offices = offices))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido obtener las sucursales',
          });
        });
    },
    async getRegionsFromApi(service_id) {
      const response = await getRegions(service_id);
      return response.data.data;
    },
    async getCommunesFromApi(region_id, service_id) {
      const response = await getCommunes(region_id, service_id);
      return response.data.data;
    },
    async getOfficesFromApi(commune_id, service_id) {
      const response = await getOffices(commune_id, service_id);
      return response.data.data;
    },
  },
};
</script>
